export class QuotaException {
  constructor(quota, currentNumber) {
    this.message = quota.QuotaName;
    this.quota = quota;
    this.currentlyDeployed = currentNumber;
    this.name = 'QuotaException';
    this.code = 412;
  }
}
